import React from 'react';
import { connect } from 'react-redux';
import {
  selectSpoofingInfo,
  SpoofingInfo,
} from 'src/features/header/store/slice';
import { RootState } from 'src/app/store';
import {
  quitSpoofingQueryParamValue,
  spoofingQueryParamName,
} from 'src/commons/constants';
import { HeaderLink } from '../styles';

export const SpoofingInfoComponent: React.VFC<{
  spoofingInfo: SpoofingInfo;
}> = ({ spoofingInfo }) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(spoofingQueryParamName, quitSpoofingQueryParamValue);
  const quitSpoofingUrl =
    window.location.pathname + '?' + queryParams.toString();

  return (
    <HeaderLink
      href={quitSpoofingUrl}
      data-ccx-e2e-id="aac-quit-spoofing"
      inverted
    >
      {spoofingInfo.quitButton.label}
    </HeaderLink>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    spoofingInfo: selectSpoofingInfo(state),
  };
};

export default connect(mapStateToProps)(SpoofingInfoComponent);
